const value = {
    pageTitle: 'Создание Юнита',
    stepSettings: 'Настройки',
    stepTheory: 'Теория',
    stepTest: 'Квиз',
    stepPractice: 'Практика',
    stepResult: 'Результат',
    newUnit: 'Новый Юнит',
    taskOne: 'Задача 1',
    task: 'Задача',
    codeReview: 'Проверка кода',
    chapterNumber: 'Глава {{number}}',
    clearChapter: 'Очистить главу',
    addingInfo: 'Двойной щелчок или перетащите компонент для добавления',
    chapters: 'Главы',
    text: 'Текст',
    heading1: 'Заголовок 1',
    heading2: 'Заголовок 2',
    heading3: 'Заголовок 3',
    p: 'Абзац',
    list: 'Список',
    listNumeric: 'Нумерованный',
    listBullet: 'Маркерованный',
    table: 'Таблица',
    columns: 'Колонки',
    rows: 'Строки',
    tableTitle: 'Заголовок таблицы',
    cellText: 'Текст ячейки',
    media: 'Медиа',
    img: 'Изображение',
    video: 'Видео',
    codeExample: 'Пример кода',
    codeLang: 'Язык',
    spacing: 'Интервал',
    spacingSize: 'Интервал {{size}}',
    nesting: 'Вложенность',
    hiddenBlock: 'Скрытый блок',
    tabs: 'Вкладки',
    tabCount: 'Вкладка {{count}}',
    tags: 'Теги',
    tagCount: 'Тег {{count}}',
    specialBlock: 'Специальный блок',
    chapterName: 'Название главы',
    title: 'Заголовок',
    link: 'Ссылка',
    linkHelper: "Указать полный путь к файлу c раширением. Пример 'http://domain/video.mp4'.",
    linkExtsError: 'Ссылка должна содержать полный путь к файлу, включая расширения .mp4/webm/ogg',
    file: 'Файл',
    color: 'Цвет',
    colorNameWarning: 'Предупреждение',
    colorNameSecondary: 'Определение',
    colorNameMain: 'Таблица',
    colorNameSuccess: 'Поощрение',
    colorNameError: 'Ошибка',
    colorNameInfo: 'Информация',
    quantity: 'Количество',
  };

export default value;
